// Mock PR data for demo/testing purposes
export const mockPRData = {
  summary: {
    total_placements: 111,
    total_reach: 1533000,
    total_engagement: 36100,
    avg_engagement_rate: 2.35,
    avg_domain_authority: 87,
    placement_growth: 15,
    reach_growth: 22,
    engagement_growth: 18,
    da_growth: 5,
  },
  monthly_data: [
    { 
      month: 'Aug 2025', 
      placements: 12, 
      reach: 145000, 
      engagement: 3200 
    },
    { 
      month: 'Sep 2025', 
      placements: 18, 
      reach: 230000, 
      engagement: 5100 
    },
    { 
      month: 'Oct 2025', 
      placements: 15, 
      reach: 198000, 
      engagement: 4300 
    },
    { 
      month: 'Nov 2025', 
      placements: 22, 
      reach: 310000, 
      engagement: 7800 
    },
    { 
      month: 'Dec 2025', 
      placements: 19, 
      reach: 265000, 
      engagement: 6200 
    },
    { 
      month: 'Jan 2026', 
      placements: 25, 
      reach: 385000, 
      engagement: 9500 
    }
  ],
  top_placements: [
    {
      publication: 'Forbes',
      date: '2026-01-10',
      reach: 120000,
      engagement: 3200,
      domain_authority: 95,
      url: 'https://forbes.com/sample-article'
    },
    {
      publication: 'TechCrunch',
      date: '2026-01-15',
      reach: 85000,
      engagement: 2400,
      domain_authority: 93,
      url: 'https://techcrunch.com/sample-article'
    },
    {
      publication: 'Business Insider',
      date: '2025-12-28',
      reach: 95000,
      engagement: 1800,
      domain_authority: 92,
      url: 'https://businessinsider.com/sample-article'
    },
    {
      publication: 'The Verge',
      date: '2025-12-15',
      reach: 78000,
      engagement: 2100,
      domain_authority: 90,
      url: 'https://theverge.com/sample-article'
    },
    {
      publication: 'VentureBeat',
      date: '2025-11-22',
      reach: 62000,
      engagement: 1500,
      domain_authority: 87,
      url: 'https://venturebeat.com/sample-article'
    },
    {
      publication: 'Industry Weekly',
      date: '2025-11-18',
      reach: 28000,
      engagement: 680,
      domain_authority: 65,
      url: 'https://industryweekly.com/sample-article'
    },
    {
      publication: 'Fast Company',
      date: '2025-11-05',
      reach: 105000,
      engagement: 2800,
      domain_authority: 91,
      url: 'https://fastcompany.com/sample-article'
    },
    {
      publication: 'Wired',
      date: '2025-10-28',
      reach: 92000,
      engagement: 2200,
      domain_authority: 93,
      url: 'https://wired.com/sample-article'
    },
    {
      publication: 'Mashable',
      date: '2025-10-12',
      reach: 71000,
      engagement: 1900,
      domain_authority: 89,
      url: 'https://mashable.com/sample-article'
    },
    {
      publication: 'TechTarget',
      date: '2025-09-30',
      reach: 45000,
      engagement: 1100,
      domain_authority: 78,
      url: 'https://techtarget.com/sample-article'
    }
  ],
  metadata: {
    start_date: '2025-08-01',
    end_date: '2026-01-22',
    months_returned: 6,
    generated_at: new Date().toISOString(),
    data_source: 'pr_tracking_system'
  }
};